import { useRef } from 'react';

export const useValueRef = (value) => {
  const valueRef = useRef(value);
  valueRef.current = value;
  return valueRef;
};
